import { render, staticRenderFns } from "./CameraEdit.vue?vue&type=template&id=2c8d19b0"
import script from "./CameraEdit.vue?vue&type=script&lang=ts"
export * from "./CameraEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports